import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Language } from '../../i18n.config';
import './LanguagePills.css';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  /** Light surfaces use tan/black pills (white form cards). Dark uses white-outline pills. */
  surface?: 'light' | 'dark';
};

/** Map legacy Spanish-only values to the EN & ES pill for display. */
function normalizeSpokenLanguage(value?: string): string | undefined {
  if (value === Language.Spanish) {
    return Language.Both;
  }
  return value;
}

export function LanguagePills({ value, onChange, surface = 'light' }: Props) {
  const { t } = useTranslation();
  const selectedValue = normalizeSpokenLanguage(value);

  const options = [
    { value: Language.English, label: t('common.english') },
    { value: Language.Both, label: t('common.en_and_es') },
  ];

  return (
    <div
      className={classNames('language-pills', {
        'language-pills--black-theme': surface === 'dark',
      })}
      role="radiogroup"
      aria-label={t('profile.language_label')}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={selectedValue === option.value}
          className={classNames('language-pills__pill', {
            'language-pills__pill--active': selectedValue === option.value,
          })}
          onClick={() => onChange?.(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
